import Vue from "vue";
import Vuex from "vuex";
import menu from "@/store/module/menu";
import { storageKey } from "@/utils/config";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    defaultActive: localStorage.defaultActive
      ? localStorage.defaultActive
      : "1",
    islogin: localStorage.islogin,
    userId: localStorage.userId || 0,
    coId: localStorage.coId,
    sofId: localStorage.sofId || "11",
    coName: localStorage.coName,
    coLogo: localStorage.coLogo,
    imageUrlHead: localStorage.imageUrlHead
      ? localStorage.imageUrlHead
      : "http://",
    userName: localStorage.userName || "",
    userPhone: localStorage.userPhone || "",
    userAccount: localStorage.userAccount || "",
    userEmail: localStorage.userEmail || "",
    token: localStorage.token || "",
    areaCode: localStorage.areaCode || "",
    language: localStorage.getItem("language") || "zh",
  },
  getters: {
    defaultActive: (state) => {
      return state.defaultActive;
    },
    islogin: (state) => {
      return state.islogin;
    },
    userId: (state) => {
      return state.userId;
    },
    coId: (state) => {
      return state.coId;
    },
    sofId: (state) => {
      return state.sofId;
    },
    coName: (state) => {
      return state.coName;
    },
    coLogo: (state) => {
      return state.coLogo;
    },
    imageUrlHead: (state) => {
      return state.imageUrlHead;
    },
    getIsCoVersion: ({ sofId }) => sofId === "95",
    getUserName: ({ userName }) => userName,
    getUserPhone: ({ userPhone }) => userPhone,
    getUserAccount: ({ userAccount }) => userAccount,
    getToken: ({ token }) => token,
    getAreaCode: ({ areaCode }) => areaCode,
    getUserEmail: ({ userEmail }) => userEmail,
  },
  mutations: {
    setDefaultActive: (state, payLoad) => {
      localStorage.setItem("defaultActive", payLoad);
      state.defaultActive = payLoad;
    },
    checkLogin: (state, payLoad) => {
      localStorage.setItem("islogin", payLoad);
      state.islogin = payLoad;
    },
    setUserId: (state, payLoad) => {
      localStorage.setItem("userId", payLoad);
      state.userId = payLoad;
    },
    setcoId: (state, payLoad) => {
      localStorage.setItem("coId", payLoad);
      state.coId = payLoad;
    },
    setSofId: (state, payLoad) => {
      localStorage.setItem("sofId", payLoad);
      state.sofId = payLoad;
    },
    setcoName: (state, payLoad) => {
      localStorage.setItem("coName", payLoad);
      state.coName = payLoad;
    },
    setcoLogo: (state, payLoad) => {
      localStorage.setItem("coLogo", payLoad);
      state.coLogo = payLoad;
    },
    setImageUrlHead: (state, payLoad) => {
      localStorage.setItem("imageUrlHead", payLoad);
      state.imageUrlHead = payLoad;
    },
    setUserName: (state, payLoad) => {
      localStorage.setItem("userName", payLoad);
      state.userName = payLoad;
    },
    setUserPhone: (state, payLoad) => {
      localStorage.setItem("userPhone", payLoad);
      state.userPhone = payLoad;
    },
    setToken: (state, payLoad) => {
      localStorage.setItem("token", payLoad);
      state.token = payLoad;
    },
    setAreaCode: (state, payLoad) => {
      localStorage.setItem("areaCode", payLoad);
      state.areaCode = payLoad;
    },
    setUserAccount: (state, payload) => {
      localStorage.setItem("userAccount", payload);
      state.userAccount = payload;
    },
    setUserEmail: (state, payload) => {
      localStorage.setItem("userEmail", payload);
      state.userEmail = payload;
    },
    setLanguage: (state, payload) => {
      state.language = payload;
      localStorage.setItem("language", payload);
    },
    logoutUser: (state) => {
      const remove = [
        "token",
        "userId",
        "userPhone",
        "userName",
        "sofId",
        "VerifyContractEditState",
        storageKey.company,
        storageKey.tenant,
        storageKey.user,
        storageKey.companyList,
      ];
      for (const item of remove) {
        localStorage.removeItem(item);
        state[item] = item.indexOf("Id") !== -1 ? 0 : "";
      }
    },
  },
  actions: {
    setDefaultActive: ({ commit }, payLoad) => {
      commit("setDefaultActive", payLoad);
    },
    checkLogin: ({ commit }, payLoad) => {
      commit("checkLogin", payLoad);
    },
    setUserId: ({ commit }, payLoad) => {
      commit("setUserId", payLoad);
    },
    setcoId: ({ commit }, payLoad) => {
      commit("setcoId", payLoad);
    },
    setSofId: ({ commit }, payLoad) => {
      commit("setSofId", payLoad);
    },
    setloginName: ({ commit }, payLoad) => {
      commit("setloginName", payLoad);
    },
    setcoName: ({ commit }, payLoad) => {
      commit("setcoName", payLoad);
    },
    setcoLogo: ({ commit }, payLoad) => {
      commit("setcoLogo", payLoad);
    },
    setImageUrlHead: ({ commit }, payLoad) => {
      commit("setImageUrlHead", payLoad);
    },
  },
  modules: {
    menu,
  },
});
